import { useState, useEffect, useCallback } from 'react';
import { listCountries } from '../services/api';
import type { CountryVisit } from '../types';

export function useCountries(scope: 'mine' | 'family' | 'all' = 'mine') {
  const [countries, setCountries] = useState<CountryVisit[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCountries = useCallback(() => {
    setLoading(true);
    listCountries(scope)
      .then(setCountries)
      .catch((err: Error & { status?: number }) => {
        if (err.status !== 401) setError(err.message);
      })
      .finally(() => setLoading(false));
  }, [scope]);

  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  return { countries, loading, error, refetch: fetchCountries };
}
